import React, { Component } from 'react';
import { connect } from 'react-redux';

import Papa from 'papaparse';

import {
	CSV_TEMPLATE_SCHEMA,
	CSV_TEMPLATE_VARIANT_SCHEMA,
	DDNY_MODEL_SCHEMA,
} from '../../../../constants/ddny';

import sectionStyles from './_styles/ManageSection.module.scss';
import styles from './_styles/ManageExport.module.scss';

import * as ddnyActionCreators from '../../../../actions/ddny';
const allActionCreators = Object.assign({}, ddnyActionCreators);

export class ManageExport extends Component {

	constructor(props) {
		super(props);
		this.state = {
			exportData: [],
			exportPending: false,
			exportComplete: false,

			exportRecords: null,
			exportRecordsComplete: 0,
		};

		this.allFields = Object.values(DDNY_MODEL_SCHEMA).flatMap(section => section.fields);
	}

	getExportPercent() {
		if(!this.state.exportRecords) {
			return 0;
		}
		return this.state.exportRecordsComplete / this.state.exportRecords;
	}

	getRowData(colHeader, productData) {
		
		// Check model fields
		for(const field of this.allFields) {
			if(field.csvKey && field.csvKey === colHeader) {
				return productData[field.apiKey];
			}
		}

		// Check model attributes
		for(const attr of this.props.ddny.attributes) {
			if(attr.type?.csv_header === colHeader) {
				for(const attrVal of attr.attributes) {
					for(const productAttr of productData.attributes) {
						if(attrVal.attribute_type === productAttr.attribute_type && attrVal.data_key === productAttr.data_key) {
							return productAttr.data_key;
						}
					}
				}
			}
		}

		return '';
	}

	getVariantData(colHeader, variantData) {
		// Check model fields
		for(const field of this.allFields) {
			if(field.csvKey && field.csvKey === colHeader) {
				return variantData[field.apiKey] || '';
			}
		}
		return '';
	}

	createCsvRow(productData) {
		const rowData = {};
		for(const col of CSV_TEMPLATE_SCHEMA) {
			if(!CSV_TEMPLATE_VARIANT_SCHEMA.includes(col)) {
				rowData[col] = this.getRowData(col, productData);
			}
		}
		return rowData;
	}

	createAttributeCsvRows(productData) {
		if(productData?.variants?.length > 0) {
			const rows = [];
			for(const vnt of productData.variants) {
				const rowData = {};
				for(const col of CSV_TEMPLATE_SCHEMA) {
					if(!CSV_TEMPLATE_VARIANT_SCHEMA.includes(col)) {
						rowData[col] = this.getRowData(col, productData);
					} else {
						rowData[col] = this.getVariantData(col, vnt);
					}
				}
				rows.push(rowData);
			}
			return rows;
		}
		return [ this.createCsvRow(productData) ];
	}

	async fetchExportPage(pageNum) {

		const pageControls = {
			page: pageNum,
			size: 100,
		};

		const pageData = await this.props.ddnyFetchProductPage(pageControls);

		return pageData;
	}

	async initiateExport() {
		this.setState({
			exportData: [],
			exportPending: true,
			exportComplete: false,
			exportRecords: null,
			exportRecordsComplete: 0,
		});

		if(!this.props.ddny.attributes) {
			await this.props.ddnyFetchAttributes();
		}
		
		let exportFinished = false;
		let exportLines = [];
		let exportPage = 1;
		let productsProcessed = 0;

		while(!exportFinished) {

			const pageData = await this.fetchExportPage(exportPage);

			for(const datum of pageData.data) {
				exportLines.push(...this.createAttributeCsvRows(datum));
				productsProcessed++;
			}

			this.setState({
				exportRecords: pageData.count,
				exportRecordsComplete: productsProcessed,
			});

			if(pageData.data.length === 0 || productsProcessed >= pageData.count) {
				exportFinished = true;
				this.setState({
					exportData: exportLines,
				});
			}

			exportPage++;
			if(exportPage > 10) {
				// Prevent infinite loop in case of an error
				exportFinished = true;
				console.error('Export process exceeded 100 pages, stopping to prevent infinite loop.');
			}
		}

		this.setState({
			exportPending: false,
			exportComplete: true,
		})
	}

	async handleDownload() {
		
		const now = Date.now();
		const exp = Papa.unparse(this.state.exportData);
		const expData = new Blob([ exp ], { type: 'text/csv;charset=utf-8;' });
		const expURL = navigator.msSaveBlob ? navigator.msSaveBlob(expData, `export-${now}.csv`) : window.URL.createObjectURL(expData);

		let expLink = document.createElement('a');
		expLink.href = expURL;
		expLink.setAttribute('download', `export-${now}.csv`);
		expLink.click();
	}

	render() {

		return <div className={`${styles.ManageExport} ${sectionStyles.ManageSection}`}>
			<div className={sectionStyles.sectionTitle}>Export Products</div>
			<div className={sectionStyles.sectionBody}>
				{!this.state.exportPending && !this.state.exportComplete
					?	<div className={styles.exportStart}>
							<div className={styles.actionWrapper}>
								<div className={styles.label}>Export all DDNY products in a CSV file</div>
								<button className={`${styles.action} actionButton`} onClick={this.initiateExport.bind(this)}>
									Initiate Export
								</button>
							</div>
						</div>
					:	<>
							{this.state.exportPending
								?	<div className={styles.exportPending}>
										<div className={styles.pendingWrapper}>
											<div className={styles.pendingCopy}>
												{`Export in progress${parseFloat(this.getExportPercent()) ? `: ${Math.round(100*parseFloat(this.getExportPercent()))}%` : ''}`}
											</div>
										</div>
									</div>
								:	<div className={styles.exportComplete}>
										<div className={styles.actionWrapper}>
											<div className={styles.label}>Export complete! Click below to downlod the export file.</div>
											<button className={`${styles.action} actionButton`} onClick={this.handleDownload.bind(this)}>
												Download
											</button>
										</div>
									</div>
							}
						</>
				}
							
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {
		ddny: state.ddny,
	};
}

export default connect(mapStateToProps, allActionCreators)(ManageExport);